/**
 * Themes with a fixed, hand-picked palette (dark bands, tinted backgrounds) take the owner's primary colour through CSS variables.
 * Only returned when the owner has chosen a colour: otherwise the theme's own palette (the variable defaults) applies unchanged.
 */
const hsl = (hex) => {
  const n = parseInt(hex.slice(1), 16);
  const r = ((n >> 16) & 255) / 255, g = ((n >> 8) & 255) / 255, b = (n & 255) / 255;
  const mx = Math.max(r, g, b), mn = Math.min(r, g, b), l = (mx + mn) / 2, d = mx - mn;
  if (!d) return [0, 0, l * 100];
  const s = d / (1 - Math.abs(2 * l - 1));
  const h = mx === r ? ((g - b) / d) % 6 : mx === g ? (b - r) / d + 2 : (r - g) / d + 4;
  return [Math.round((h * 60 + 360) % 360), s * 100, l * 100];
};
const tone = (h, s, l) => `hsl(${h} ${Math.round(Math.max(0, Math.min(100, s)))}% ${Math.round(l)}%)`;
const valid = (v) => /^#[0-9a-f]{6}$/i.test(v || "");

/** Verdant Drops: the deep forest bands, light tints and lines are shades of the primary colour. */
export function verdantVars(primary) {
  if (!valid(primary)) return {};
  const [h, s] = hsl(primary);
  const sat = s < 8 ? s : Math.min(Math.max(s, 35), 70);
  return {
    "--v-deep": tone(h, sat * 0.8, 11), "--v-forest": tone(h, sat * 0.75, 15), "--v-glow": tone(h, sat * 0.75, 22),
    "--v-leaf": tone(h, sat, 76), "--v-cream": tone(h, sat * 0.9, 96), "--v-mist": tone(h, sat * 0.8, 92), "--v-line": tone(h, sat * 0.6, 86),
    "--v-muted": tone(h, sat * 0.3, 40), "--v-em": tone(h, sat, 35),
  };
}

/** MediStore: the navy headings, bands and buttons are the primary colour. */
export function mediVars(primary) {
  return valid(primary) ? { "--m-navy": primary } : {};
}
